import { plural } from '@cian/utils';
import { ACCESS_TYPE_LABELS } from 'shared/constants/buildingLabels';
import { NBSP } from 'shared/constants/text';
import type { IBuildingCard } from 'shared/types/buildingCard';

import { type IMergedOpeningHours, mergeOpeningHours } from './mergeOpeningHours';

/** Подпись склеенного интервала сравнивается целиком, как в `detail/index.html` монолита */
const DAYS_DISPLAY: Partial<Record<string, string>> = {
  'Рабочие дни': `По${NBSP}будням`,
  Выходные: `По${NBSP}выходным`,
};

function getHoursLine({ label, from, to, roundTheClock }: IMergedOpeningHours): string {
  const days = DAYS_DISPLAY[label] ?? label;

  if (roundTheClock) {
    return label === 'Ежедневно' ? `${days}, круглосуточно` : `${days} – круглосуточно`;
  }

  // Пробелы как в шаблоне монолита: «&nbsp;с&nbsp;08:00 до&nbsp;23:00» — дни не отрываются от времени
  const fromText = from ? `${NBSP}с${NBSP}${from}` : '';
  const toText = to ? `${from ? ' ' : NBSP}до${NBSP}${to}` : '';

  return `${days}${fromText}${toText}`;
}

/** Значение «Доступ в здание»: доступ и входы, затем часы работы. Пустой массив — строку не выводим */
export function getAccessLines(card: IBuildingCard): string[] {
  const access = card.accessType ? ACCESS_TYPE_LABELS[card.accessType] : undefined;
  const { entranceCount } = card;
  const entrances = entranceCount
    ? `${entranceCount}${NBSP}${plural(entranceCount, ['вход', 'входа', 'входов'])}`
    : undefined;
  const lines: string[] = [];

  if (access || entrances) {
    lines.push([access, entrances].filter(Boolean).join(', '));
  }

  return [...lines, ...mergeOpeningHours(card.openingHours).map(getHoursLine)];
}
